__turbopack_context__.v({
  "actionButton": "k1ZY8q_actionButton",
  "modalBackground": "k1ZY8q_modalBackground",
  "modalContainer": "k1ZY8q_modalContainer",
  "modalContent": "k1ZY8q_modalContent",
  "modalFooter": "k1ZY8q_modalFooter",
  "modalNamespace": "k1ZY8q_modalNamespace",
  "narrowModal": "k1ZY8q_narrowModal",
  "wideModal": "k1ZY8q_wideModal",
});
